import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { PhotoNodeView } from "@/components/editor/nodeviews/PhotoNodeView";

/**
 * Profile photo / avatar block — used in CVs and similar headers.
 * Geometry attributes (size, shape, position) drive both the editor
 * preview and the LaTeX includegraphics geometry.
 */
export const PhotoBlock = Node.create({
  name: "photoBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      src: { default: "" },
      alt: { default: "" },
      shape: { default: "square" },        // square | round
      size: { default: 64 },               // pt
      position: { default: "right" },      // left | center | right
      border: { default: 0 },              // px
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="photo-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "photo-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(PhotoNodeView);
  },
});
